import { useAppSelector } from '@/store';
import { selectIsOnline } from '@/store/slices/app/networkStatus';
import { ExclamationTriangleIcon } from '@repo/atomic-components';

export const InternetConnectionBanner = () => {
  const isOnline = useAppSelector(selectIsOnline);

  if (isOnline) return null;

  return (
    <div className="flex h-9 w-full items-center justify-center bg-[#E85147] px-6 py-1">
      <div className="flex items-center gap-1">
        <ExclamationTriangleIcon className="h-5 w-5" fill="#FDEEED" />
        <span className="text-sm font-bold text-[#FDEEED]">Internet connection lost</span>
      </div>
    </div>
  );
};
